<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/client">Clientes</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Atualizar Quadro Societário (QSA) / {{
                    client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <tabMenuClient :id="client.id" :type="client.type"></tabMenuClient>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <div
                                    class="card-header py-3 mb-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 class="m-0 font-weight-bold text-primary pointer" data-toggle="collapse"
                                        data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"><i
                                            class="fa" :class="text_label == 'Adicionar sócio'?'fa-plus':'fa-edit'"></i> {{ text_label }}</h6>
                                </div>
                                <div class="card-body">
                                    <form @submit="update">
                                        <div class="row mt-2">
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">CPF*</label>
                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control"
                                                        placeholder="Ex: xxx.xxx.xxx-xx"
                                                        v-model="client_corporate_structure.document"
                                                        v-mask="['###.###.###-##']">

                                                </div>
                                            </div>
                                            <div class="col-xl-8 col-md-8 col-sm-12">
                                                <label for="">Nome*</label>
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: Antônio da Silva"
                                                    v-model="client_corporate_structure.name">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Telefone*</label>
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: (xx)x.xxxx-xxxx"
                                                    v-model="client_corporate_structure.phone"
                                                    v-mask="['(##) ####-####', '(##) #####-####']">
                                            </div>
                                            <div class="col-xl-8 col-md-8 col-sm-12">
                                                <label for="">E-mail*</label>
                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control"
                                                        placeholder="Ex: usuario@dominio.com"
                                                        v-model="client_corporate_structure.email">

                                                </div>
                                            </div>

                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-xl-12 col-md-12 col-sm-12">
                                                <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                        class="fa fa-save"></i> {{
                                                            button_action
                                                        }}</button>
                                                <button type="button" @click="cancel" class="btn btn-danger ml-3"><i
                                                        class="fa fa-times"></i>
                                                    Cancelar</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <div
                                    class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 class="m-0 font-weight-bold text-primary">Sócios</h6>
                                </div>
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <div class="table-responsive">
                                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Nome</th>
                                                        <th class="text-center">Documento</th>
                                                        <th class="text-center">E-mail</th>
                                                        <th class="text-center">Telefone</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(client_corporate_structure, index) in client_corporate_structure_saved"
                                                        :key="client_corporate_structure.id">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ client_corporate_structure.name }} </td>
                                                        <td class="text-center">{{ client_corporate_structure.document_formatted }}</td>
                                                        <td class="text-center">{{ client_corporate_structure.email }}</td>
                                                         <td class="text-center">{{ client_corporate_structure.phone_formatted }}</td>
                                                        <td>
                                                            <div class="dropdown">
                                                                <button class="btn btn-primary dropdown-toggle"
                                                                    type="button" id="dropdownMenuButton"
                                                                    data-toggle="dropdown" aria-haspopup="true"
                                                                    aria-expanded="false">
                                                                    Ações
                                                                </button>
                                                                <div class="dropdown-menu animated--fade-in"
                                                                    aria-labelledby="dropdownMenuButton">
                                                                    <button class="dropdown-item"
                                                                        @click="editCorporateStructure(client_corporate_structure.id)">Editar</button>
                                                                    <button class="dropdown-item"
                                                                        @click="deletecorporateStructure(client_corporate_structure.id)">Excluir</button>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-show="client_corporate_structure_saved.length <= 0">
                                                        <td colspan="7" class="text-center">Nenhum registro encontrado
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import tabMenuClient from './tab-menu-client.vue';


export default {
    directives: { mask },
    components: { Loading, tabMenuClient },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            client: {},
            client_corporate_structure_saved: {},
            client_id: '',
            action_save: true,
            text_label: 'Adicionar sócio',
            button_action: 'Cadastrar',
            total_service: 0.00,
            client_corporate_structure: {
                id: '',
                document: '',
                name: '',
                email: '',
                phone: '',
                id_corporate_structure_client:''
            },
            enable_error_list: false,
            errors: [],

        }
    },

    computed: {
        isDisabled: function () {
            return this.client_corporate_structure.name != '' && this.client_corporate_structure.document != '' && this.client_corporate_structure.email != '' && this.client_corporate_structure.phone != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.client_id = id;
        this.getCorporateStructureClient();

    },
    methods: {
        onCancel() { },
        cancel() {
            this.action_save = false;
            this.client_corporate_structure = { document: '', name: '', email: '', phone: '' };
            this.services = {};
            this.client_corporate_structure_saved = {};
            this.text_label = 'Adicionar sócio';
            this.button_action = 'Cadastrar';
            this.getCorporateStructureClient();
        },
        setCapitalize(text) {
            return capitalize(text);
        },

        formatReal(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },



        getCorporateStructureClient() {
            this.isLoading = true;
            api.get('/client/' + this.client_id + '/corporateStructure')
                .then((response) => {
                    this.isLoading = false;
                    this.client = response.data.client;
                    this.client_corporate_structure_saved = response.data.corporate_structure_client;

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        update(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/client/' + this.client.id + '/corporateStructure', this.client_corporate_structure)
                .then(() => {
                    this.isLoading = false;
                    if (this.action_save) {
                        this.$notify({
                            title: "Sucesso",
                            text: "Sócio adicionado com sucesso!",
                            type: 'success'
                        });
                    } else {
                        this.$notify({
                            title: "Sucesso",
                            text: "Sócio atualizado com sucesso!",
                            type: 'success'
                        });
                    }

                    this.cancel();

                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        },
        editCorporateStructure(corporate_structure_id) {
            this.text_label = 'Atualizar sócio';
            this.button_action = 'Atualizar';
            this.client_corporate_structure_saved.forEach(corporate_structure => {
                if (corporate_structure.id == corporate_structure_id) {

                    this.client_corporate_structure.id = corporate_structure.id;
                    this.client_corporate_structure.name = corporate_structure.name;
                    this.client_corporate_structure.document = corporate_structure.document;
                    this.client_corporate_structure.email = corporate_structure.email;
                    this.client_corporate_structure.phone = corporate_structure.phone;
                    this.client_corporate_structure.id_corporate_structure_client = corporate_structure_id;

                }
            });
        },
        deletecorporateStructure(corporate_structure_id) {
            this.$confirm(
                {
                    message: 'Deseja retirar o sócio do quadro?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('client/' + corporate_structure_id + '/corporateStructure')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Sócio removido com sucesso",
                                        type: 'success'
                                    });

                                    this.cancel();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        }
    }
}
</script>

<style>
.pointer {
    cursor: pointer;
}
</style>